// extracted by mini-css-extract-plugin
export var container = "_dw-1";
export var cornerButtonContainer = "_dw-6";
export var disabled = "_dw-2";
export var dragActive = "_dw-3";
export var fileContainer = "_dw-5";
export var hiddenInput = "_dw-4";
export var widthContainer = "_dw-0";